module.exports = __webpack_public_path__ + "static/media/DK4050_04.46aca598.jpg";